"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.States = void 0;
var States;
(function (States) {
    States["INITIALIZING"] = "@state/INITIALIZING";
    States["FETCHING_CONFIG"] = "@state/FETCHING_CONFIG";
    States["DONE"] = "@state/DONE";
    States["ERROR"] = "@state/ERROR";
    States["FETCHING_TYPEAHEAD_SUGGESTIONS"] = "@state/FETCHING_TYPEAHEAD_SUGGESTIONS";
    States["NO_RESULTS"] = "@state/NO_RESULTS";
    States["TYPEAHEAD_CLOSED"] = "@state/TYPEAHEAD_CLOSED";
    States["TYPEAHEAD_OPEN"] = "@state/TYPEAHEAD_OPEN";
    States["IDLE"] = "@state/IDLE";
    States["CHECKING_CONFIG"] = "@state/CHECKING_CONFIG";
    States["CHECKING_LOGGER"] = "@state/CHECKING_LOGGER";
    States["INITIALIZING_LOGGING"] = "@state/INITIALIZING_LOGGING";
    States["ACCEPTING_USER_INPUT"] = "@state/ACCEPTING_USER_INPUT";
    States["FILLING_IN_CONFIG_DEFAUTLS"] = "@state/FILLING_IN_CONFIG_DEFAUTLS";
    States["PREVIEW"] = "@state/PREVIEW";
    States["EMPTY_SEARCH_ERROR"] = "@state/EMPTY_SEARCH_ERROR";
})(States = exports.States || (exports.States = {}));
//# sourceMappingURL=states.js.map